import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "favourite-panel favourite-panel--empty" }
const _hoisted_2 = { class: "favourite-panel__filters" }
const _hoisted_3 = { class: "favourite-panel__body" }
const _hoisted_4 = { class: "favourite-panel__body-item-text" }
const _hoisted_5 = { class: "favourite-panel__body-item-text-type" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "favourite-panel__body-item-text-description" }
const _hoisted_8 = {
  key: 0,
  class: "favourite-panel__body-empty"
}
const _hoisted_9 = {
  key: 1,
  class: "favourite-panel__empty"
}

import { computed, onMounted, ref } from "vue";
import AppInput from "@/components/ui-kit/input/AppInput.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import { Favourite, favouritesStore } from "@/store/favourites";
import { escapeHtml, highlightSearchText } from "@/utils/textHelpers";
import { orderBy } from "lodash";
import { useRoute } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatFavouritePanel',
  setup(__props) {

const route = useRoute();
const store = favouritesStore();
const favourites = computed(() => store.favouritesList);
const sortType = ref<"asc" | "desc" | null>(null);
const showClients = ref(true);
const showProjects = ref(true);
const searchText = ref("");

const filteredFavourites = computed(() => {
  if (!favourites.value) return null;

  let modifiedFavourites = favourites.value.filter((favourite) =>
    favourite.Title.toLowerCase().includes(searchText.value.toLowerCase()),
  );

  if (!showClients.value) {
    modifiedFavourites = modifiedFavourites.filter(
      (favourite) => favourite.Type !== 0,
    );
  }

  if (!showProjects.value) {
    modifiedFavourites = modifiedFavourites.filter(
      (favourite) => favourite.Type !== 1,
    );
  }

  return sortType.value
    ? orderBy(
        modifiedFavourites,
        ["Type", "Title"],
        [sortType.value, sortType.value],
      )
    : modifiedFavourites;
});

const changeFavouriteSort = () => {
  switch (sortType.value) {
    case "asc":
      sortType.value = "desc";
      return;
    case "desc":
      sortType.value = null;
      return;
    default:
      sortType.value = "asc";
      return;
  }
};

const getFavouriteName = (favourite: Favourite) => {
  const name =
    favourite.Type === 0
      ? (favourite.Client?.Name ?? "")
      : (favourite.Project?.Name ?? "");

  return highlightSearchText(searchText.value, escapeHtml(name));
};

const getFavouriteDescription = (favourite: Favourite) => {
  return favourite.Type === 0
    ? mapParams(favourite.Client!.Parameters)
    : mapParams(favourite.Project!.Parameters);
};

const mapParams = (param: object[]) => {
  return param
    .map((p) =>
      p.Instance
        ? `${p.Instance.Key}: ${p.Instance.Value}`
        : mapParams(p.ListTitle),
    )
    .flat(2)
    .join(", ");
};

const deleteFromFavourites = async (favourite: Favourite) => {
  if (favourite.Type === 0) {
    await store.removeFavourites(favourite.Client!.Id, favourite.Type);
  } else {
    await store.removeFavourites(favourite.Project!.Id, favourite.Type);
  }
};

onMounted(() => {
  store.fetchFavourites(searchText.value);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (favourites.value && favourites.value.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(AppInput, {
              modelValue: searchText.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
              class: "favourite-panel__filters-input",
              placeholder: _ctx.$t('search_favourite')
            }, null, 8, ["modelValue", "placeholder"]),
            _createVNode(AppTooltip, {
              position: "top",
              text: _ctx.$t(showProjects.value ? 'chat_filter_projects_off' : 'chat_filter_projects_on')
            }, {
              activator: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass({
                'favourite-panel__filters-toggle': true,
                'favourite-panel__filters-toggle--selected': showProjects.value,
              }),
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (showProjects.value = !showProjects.value), ["stop"]))
                }, _toDisplayString(_ctx.$t('projects_label')), 3)
              ]),
              _: 1
            }, 8, ["text"]),
            _createVNode(AppTooltip, {
              position: "top",
              text: _ctx.$t(showClients.value ? 'chat_filter_clients_off' : 'chat_filter_clients_on')
            }, {
              activator: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass({
                'favourite-panel__filters-toggle': true,
                'favourite-panel__filters-toggle--selected': showClients.value,
              }),
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (showClients.value = !showClients.value), ["stop"]))
                }, _toDisplayString(_ctx.$t('clients_label')), 3)
              ]),
              _: 1
            }, 8, ["text"]),
            (!sortType.value)
              ? (_openBlock(), _createBlock(AppTooltip, {
                  key: 0,
                  position: "top",
                  text: _ctx.$t('sort_tip_str_asc')
                }, {
                  activator: _withCtx(() => [
                    (!sortType.value)
                      ? (_openBlock(), _createBlock(AppIcon, {
                          key: 0,
                          class: "favourite-panel__filters-sort",
                          name: "sort-auto",
                          width: "18px",
                          color: "#979797",
                          "hover-color": "#499259",
                          cursor: "pointer",
                          onClick: _withModifiers(changeFavouriteSort, ["stop"])
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["text"]))
              : (sortType.value === 'asc')
                ? (_openBlock(), _createBlock(AppTooltip, {
                    key: 1,
                    position: "top",
                    text: _ctx.$t('sort_tip_str_desc')
                  }, {
                    activator: _withCtx(() => [
                      _createVNode(AppIcon, {
                        class: "favourite-panel__filters-sort",
                        name: "sort-a-z",
                        width: "18px",
                        color: "#979797",
                        "hover-color": "#499259",
                        cursor: "pointer",
                        onClick: _withModifiers(changeFavouriteSort, ["stop"])
                      })
                    ]),
                    _: 1
                  }, 8, ["text"]))
                : (_openBlock(), _createBlock(AppTooltip, {
                    key: 2,
                    position: "top",
                    text: _ctx.$t('sort_tip_default')
                  }, {
                    activator: _withCtx(() => [
                      _createVNode(AppIcon, {
                        class: "favourite-panel__filters-sort",
                        name: "sort-z-a",
                        width: "18px",
                        color: "#979797",
                        "hover-color": "#499259",
                        cursor: "pointer",
                        onClick: _withModifiers(changeFavouriteSort, ["stop"])
                      })
                    ]),
                    _: 1
                  }, 8, ["text"]))
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "favourite-panel__divider" }, null, -1)),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredFavourites.value, (favourite) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "favourite-panel__body-item",
                key: favourite.Client?.Id || favourite.Project?.Id
              }, [
                _createVNode(AppTooltip, {
                  class: "favourite-panel__body-item-icon",
                  text: _ctx.$t('favourite_remove')
                }, {
                  activator: _withCtx(() => [
                    _createVNode(AppIcon, {
                      name: "favourite",
                      width: "18px",
                      color: "#D05A4F",
                      "hover-color": "#979797",
                      cursor: "pointer",
                      onClick: ($event: any) => (deleteFromFavourites(favourite))
                    }, null, 8, ["onClick"])
                  ]),
                  _: 2
                }, 1032, ["text"]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t(favourite.Type === 0 ? 'client_label' : 'project_label')), 1),
                  _createVNode(_component_router_link, {
                    to: {
                query: {
                  page: favourite.Type === 0 ? 'client' : 'project',
                  id:
                    favourite.Type === 0
                      ? favourite.Client?.Id
                      : favourite.Project?.Id,
                },
              },
                    class: "favourite-panel__body-item-text-name"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        innerHTML: getFavouriteName(favourite)
                      }, null, 8, _hoisted_6)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(getFavouriteDescription(favourite)), 1)
                ])
              ]))
            }), 128)),
            (searchText.value && !filteredFavourites.value?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('nothing_found')), 1))
              : _createCommentVNode("", true)
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('chat_favourite_empty')), 1))
  ]))
}
}

})